/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Notifications_ErrorInputs */

const es_tools_legajox_notifications_error = /** @type {(inputs: Tools_Legajox_Notifications_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar notificaciones de Legajox`)
};

const en_tools_legajox_notifications_error = /** @type {(inputs: Tools_Legajox_Notifications_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error querying Legajox notifications`)
};

/**
* | output |
* | --- |
* | "Error querying Legajox notifications" |
*
* @param {Tools_Legajox_Notifications_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_notifications_error = /** @type {((inputs?: Tools_Legajox_Notifications_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Notifications_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_notifications_error(inputs)
	return en_tools_legajox_notifications_error(inputs)
});
export { tools_legajox_notifications_error as "tools.legajox.notifications_error" }